import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { SectionHeading } from "components/misc/Headings";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900 mb-10`;
const Text = styled.div`
  ${tw`text-lg  text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;
export default ({ headingText = "Politique de Confidentialité" }) => {
  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>{headingText}</Heading>
          </HeadingRow>
          <Text>
            <p>Dernière mise à jour : 04 avril 2025</p>

            <p>
              Cette Politique de Confidentialité décrit Nos politiques et procédures concernant la collecte, l'utilisation
              et la divulgation de Vos informations lorsque Vous utilisez le Service et Vous informe de Vos droits à la
              vie privée et de la manière dont la loi Vous protège.
            </p>

            <p>
              Nous utilisons Vos données personnelles pour fournir et améliorer le Service. En utilisant le Service,
              Vous acceptez la collecte et l'utilisation d'informations conformément à cette Politique de Confidentialité.
            </p>

            <h1>Interprétation et Définitions</h1>
            <h2>Interprétation</h2>
            <p>
              Les mots dont la première lettre est en majuscule ont des significations définies sous les conditions suivantes.
            </p>
            <p>
              Les définitions suivantes auront la même signification qu'elles apparaissent au singulier ou au pluriel.
            </p>

            <h2>Définitions</h2>
            <p>Aux fins de cette Politique de Confidentialité :</p>
            <ul>
              <li>
                <p>
                  <strong>Vous</strong> désigne l'individu accédant ou utilisant le Service, ou la société, ou autre
                  entité juridique au nom de laquelle cet individu accède ou utilise le Service, selon le cas.
                </p>
              </li>
              <li>
                <p>
                  <strong>Société</strong> (désignée comme "la Société", "Nous", "Nos" ou "Notre" dans cet Accord)
                  fait référence à Tanga Group Inc.
                </p>
              </li>
              <li>
                <strong>Affilié</strong> désigne une entité qui contrôle, est contrôlée par ou est sous contrôle commun
                avec une partie, où "contrôle" signifie la propriété de 50% ou plus des actions, des intérêts ou autres
                titres donnant droit de vote pour l'élection des administrateurs ou d'autres autorités de gestion.
              </li>
              <li>
                <strong>Compte</strong> désigne un compte unique créé pour Vous afin d'accéder à Notre Service ou à des
                parties de Notre Service.
              </li>
              <li>
                <strong>Site Web</strong> fait référence à Tanga Group, accessible depuis https://tangagroup.africa
              </li>
              <li>
                <strong>Service</strong> fait référence au Site Web.
              </li>
              <li>
                <strong>Pays</strong> fait référence à : Côte d'Ivoire
              </li>
              <li>
                <p>
                  <strong>Fournisseur de Service</strong> désigne toute personne physique ou morale qui traite les
                  données au nom de la Société. Il fait référence aux sociétés tierces ou aux individus employés par
                  la Société pour faciliter le Service, fournir le Service au nom de la Société, effectuer des services
                  liés au Service ou aider la Société à analyser comment le Service est utilisé.
                </p>
              </li>
              <li>
                <strong>Service de Médias Sociaux Tiers</strong> désigne tout site web ou tout site web de réseau social
                via lequel un Utilisateur peut se connecter ou créer un compte pour utiliser le Service.
              </li>
              <li>
                <p>
                  <strong>Données Personnelles</strong> désigne toute information relative à un individu identifié ou
                  identifiable.
                </p>
              </li>
              <li>
                <strong>Cookies</strong> sont de petits fichiers placés sur Votre ordinateur, appareil mobile ou tout
                autre appareil par un site web, contenant les détails de Votre historique de navigation sur ce site
                web parmi ses nombreuses utilisations.
              </li>
              <li>
                <strong>Données d'Utilisation</strong> désigne les données collectées automatiquement, soit générées
                par l'utilisation du Service, soit provenant de l'infrastructure du Service elle-même (par exemple,
                la durée d'une visite de page).
              </li>
            </ul>

            <h1>Collecte et Utilisation de Vos Données Personnelles</h1>
            <h2>Types de Données Collectées</h2>

            <h3>Données Personnelles</h3>
            <p>
              Lors de l'utilisation de Notre Service, Nous pouvons Vous demander de Nous fournir certaines informations
              personnellement identifiables qui peuvent être utilisées pour Vous contacter ou Vous identifier. Les
              informations personnellement identifiables peuvent inclure, mais ne sont pas limitées à :
            </p>
            <ul>
              <li>Adresse e-mail</li>
              <li>Prénom et nom</li>
              <li>Numéro de téléphone</li>
              <li>Adresse, État, Province, Code postal, Ville</li>
              <li>Données d'Utilisation</li>
            </ul>

            <h3>Données d'Utilisation</h3>
            <p>Les Données d'Utilisation sont collectées automatiquement lors de l'utilisation du Service.</p>
            <p>
              Les Données d'Utilisation peuvent inclure des informations telles que l'adresse de protocole Internet de
              Votre appareil (par exemple, l'adresse IP), le type de navigateur, la version du navigateur, les pages
              de Notre Service que Vous visitez, l'heure et la date de Votre visite, le temps passé sur ces pages,
              les identifiants uniques d'appareil et autres données de diagnostic.
            </p>
            <p>
              Lorsque Vous accédez au Service par ou via un appareil mobile, Nous pouvons collecter certaines
              informations automatiquement, y compris, mais sans s'y limiter, le type d'appareil mobile que Vous
              utilisez, l'identifiant unique de Votre appareil mobile, l'adresse IP de Votre appareil mobile, Votre
              système d'exploitation mobile, le type de navigateur Internet mobile que Vous utilisez, les identifiants
              uniques d'appareil et autres données de diagnostic.
            </p>
            <p>
              Nous pouvons également collecter les informations que Votre navigateur envoie chaque fois que Vous
              visitez Notre Service ou lorsque Vous accédez au Service par ou via un appareil mobile.
            </p>

            <h3>Technologies de Suivi et Cookies</h3>
            <p>
              Nous utilisons des Cookies et des technologies de suivi similaires pour suivre l'activité sur Notre
              Service et stocker certaines informations. Les technologies de suivi utilisées sont des balises, des
              scripts et des pixels pour collecter et suivre les informations et pour améliorer et analyser Notre
              Service.
            </p>
            <p>
              Vous pouvez instruire Votre navigateur pour refuser tous les Cookies ou pour indiquer quand un Cookie
              est envoyé. Cependant, si Vous n'acceptez pas les Cookies, Vous ne pourrez peut-être pas utiliser
              certaines parties de Notre Service.
            </p>
            <p>
              Les Cookies peuvent être "Persistants" ou "Session". Les Cookies Persistants restent sur Votre
              ordinateur personnel ou appareil mobile lorsque Vous êtes hors ligne, tandis que les Cookies de Session
              sont supprimés dès que Vous fermez Votre navigateur web. En savoir plus sur les cookies : <a href="https://www.termsfeed.com/blog/cookies/">Tout sur les Cookies</a>.
            </p>
            <p>Nous utilisons à la fois des cookies de session et persistants aux fins énoncées ci-dessous :</p>
            <ul>
              <li>
                <p>
                  <strong>Cookies Nécessaires / Essentiels</strong>
                </p>
                <p>Type : Cookies de Session</p>
                <p>Administrés par : Nous</p>
                <p>
                  Objectif : Ces Cookies sont essentiels pour Vous fournir les services disponibles sur le Site Web
                  et pour Vous permettre d'utiliser certaines de ses fonctionnalités. Ils aident à authentifier les
                  utilisateurs et à prévenir l'utilisation frauduleuse des comptes utilisateurs. Sans ces Cookies, les
                  services que Vous avez demandés ne peuvent pas être fournis, et Nous n'utilisons ces Cookies que pour
                  Vous fournir ces services.
                </p>
              </li>
              <li>
                <p>
                  <strong>Cookies de Politique / Acceptation de l'Avis</strong>
                </p>
                <p>Type : Cookies Persistants</p>
                <p>Administrés par : Nous</p>
                <p>Objectif : Ces Cookies identifient si les utilisateurs ont accepté l'utilisation des cookies sur le Site Web.</p>
              </li>
              <li>
                <p>
                  <strong>Cookies de Fonctionnalité</strong>
                </p>
                <p>Type : Cookies Persistants</p>
                <p>Administrés par : Nous</p>
                <p>
                  Objectif : Ces Cookies Nous permettent de mémoriser les choix que Vous faites lorsque Vous utilisez le
                  Site Web, comme la mémorisation de Vos identifiants de connexion ou de Vos préférences de langue. Le
                  but de ces Cookies est de Vous fournir une expérience plus personnelle et d'éviter que Vous ayez à
                  réentrer Vos préférences chaque fois que Vous utilisez le Site Web.
                </p>
              </li>
            </ul>
            <p>
              Pour plus d'informations sur les cookies que Nous utilisons et Vos choix concernant les cookies, veuillez
              consulter Notre Politique de Cookies.
            </p>

            <h2>Utilisation de Vos Données Personnelles</h2>
            <p>La Société peut utiliser les Données Personnelles aux fins suivantes :</p>
            <ul>
              <li>
                <strong>Pour fournir et maintenir Notre Service</strong>, y compris pour surveiller l'utilisation de
                Notre Service.
              </li>
              <li>
                <strong>Pour gérer Votre Compte :</strong> pour gérer Votre inscription en tant qu'utilisateur du
                Service. Les Données Personnelles que Vous fournissez peuvent Vous donner accès à différentes
                fonctionnalités du Service qui sont disponibles pour Vous en tant qu'utilisateur enregistré.
              </li>
              <li>
                <strong>Pour l'exécution d'un contrat :</strong> le développement, la conformité et l'exécution du
                contrat d'achat pour les produits, articles ou services que Vous avez achetés ou de tout autre contrat
                avec Nous via le Service.
              </li>
              <li>
                <strong>Pour Vous contacter :</strong> Pour Vous contacter par e-mail, appels téléphoniques, SMS ou
                autres formes équivalentes de communication électronique, telles que les notifications push d'une
                application mobile concernant les mises à jour ou les communications informatives liées aux
                fonctionnalités, produits ou services sous contrat, y compris les mises à jour de sécurité, lorsque
                nécessaire ou raisonnable pour leur mise en œuvre.
              </li>
              <li>
                <strong>Pour Vous fournir</strong> des nouvelles, des offres spéciales et des informations générales
                sur d'autres biens, services et événements que Nous proposons et qui sont similaires à ceux que Vous
                avez déjà achetés ou sur lesquels Vous vous êtes renseigné, sauf si Vous avez choisi de ne pas recevoir
                ces informations.
              </li>
              <li>
                <strong>Pour gérer Vos demandes :</strong> Pour assister et gérer Vos demandes à Nous.
              </li>
            </ul>

            <p>Nous pouvons partager Vos informations personnelles dans les situations suivantes :</p>

            <ul>
              <li>
                <strong>Avec les Fournisseurs de Service :</strong> Nous pouvons partager Vos informations personnelles
                avec les Fournisseurs de Service pour surveiller et analyser l'utilisation de Notre Service, pour Vous
                contacter.
              </li>
              <li>
                <strong>Pour les transferts d'entreprise :</strong> Nous pouvons partager ou transférer Vos informations
                personnelles dans le cadre de, ou pendant les négociations de, toute fusion, vente d'actifs de la
                Société, financement ou acquisition de tout ou partie de Notre entreprise à une autre société.
              </li>
              <li>
                <strong>Avec les Affiliés :</strong> Nous pouvons partager Vos informations avec Nos affiliés, auquel
                cas Nous exigerons que ces affiliés respectent cette Politique de Confidentialité. Les affiliés incluent
                Notre société mère et toute autre filiale, partenaire de coentreprise ou autre société que Nous contrôlons
                ou qui est sous contrôle commun avec Nous.
              </li>
              <li>
                <strong>Avec les Partenaires commerciaux :</strong> Nous pouvons partager Vos informations avec Nos
                partenaires commerciaux pour Vous offrir certains produits, services ou promotions.
              </li>
              <li>
                <strong>Avec d'autres utilisateurs :</strong> lorsque Vous partagez des informations personnelles ou
                interagissez autrement dans les zones publiques avec d'autres utilisateurs, ces informations peuvent
                être vues par tous les utilisateurs et peuvent être distribuées publiquement à l'extérieur. Si Vous
                interagissez avec d'autres utilisateurs ou Vous inscrivez via un Service de Médias Sociaux Tiers, Vos
                contacts sur le Service de Médias Sociaux Tiers peuvent voir Votre nom, profil, photos et description
                de Votre activité. De même, d'autres utilisateurs pourront voir les descriptions de Votre activité,
                communiquer avec Vous et voir Votre profil.
              </li>
            </ul>

            <h2>Conservation de Vos Données Personnelles</h2>
            <p>
              La Société conservera Vos Données Personnelles uniquement aussi longtemps que nécessaire aux fins énoncées
              dans cette Politique de Confidentialité. Nous conserverons et utiliserons Vos Données Personnelles dans la
              mesure nécessaire pour respecter Nos obligations légales (par exemple, si Nous sommes tenus de conserver
              Vos données pour respecter les lois applicables), résoudre les litiges et faire respecter Nos accords et
              politiques légaux.
            </p>
            <p>
              La Société conservera également les Données d'Utilisation à des fins d'analyse interne. Les Données
              d'Utilisation sont généralement conservées pour une période plus courte, sauf lorsque ces données sont
              utilisées pour renforcer la sécurité ou améliorer la fonctionnalité de Notre Service, ou Nous sommes
              légalement tenus de conserver ces données pour des périodes plus longues.
            </p>

            <h2>Transfert de Vos Données Personnelles</h2>
            <p>
              Vos informations, y compris les Données Personnelles, sont traitées dans les bureaux d'exploitation de la
              Société et dans tout autre endroit où les parties impliquées dans le traitement sont situées. Cela signifie
              que ces informations peuvent être transférées à — et maintenues sur — des ordinateurs situés en dehors de
              Votre état, province, pays ou autre juridiction gouvernementale où les lois sur la protection des données
              peuvent différer de celles de Votre juridiction.
            </p>
            <p>
              Votre consentement à cette Politique de Confidentialité suivi de Votre soumission de ces informations
              représente Votre accord à ce transfert.
            </p>
            <p>
              La Société prendra toutes les mesures raisonnablement nécessaires pour s'assurer que Vos données sont
              traitées de manière sécurisée et conformément à cette Politique de Confidentialité et aucun transfert de
              Vos Données Personnelles ne sera effectué vers une organisation ou un pays sauf s'il existe des contrôles
              adéquats en place, y compris la sécurité de Vos données et autres informations personnelles.
            </p>

            <h2>Divulgation de Vos Données Personnelles</h2>
            <h3>Transactions Commerciales</h3>
            <p>
              Si la Société est impliquée dans une fusion, acquisition ou vente d'actifs, Vos Données Personnelles
              peuvent être transférées. Nous fournirons un avis avant que Vos Données Personnelles ne soient transférées
              et ne deviennent soumises à une Politique de Confidentialité différente.
            </p>
            <h3>Application de la loi</h3>
            <p>
              Dans certaines circonstances, la Société peut être tenue de divulguer Vos Données Personnelles si la loi
              l'exige ou en réponse à des demandes valides des autorités publiques (par exemple, un tribunal ou une
              agence gouvernementale).
            </p>
            <h3>Autres exigences légales</h3>
            <p>
              La Société peut divulguer Vos Données Personnelles dans la bonne foi, estimant que cette action est
              nécessaire pour :
            </p>
            <ul>
              <li>Respecter une obligation légale</li>
              <li>Protéger et défendre les droits ou la propriété de la Société</li>
              <li>Prévenir ou enquêter sur d'éventuels actes répréhensibles en lien avec le Service</li>
              <li>Protéger la sécurité personnelle des Utilisateurs du Service ou du public</li>
              <li>Se protéger contre la responsabilité légale</li>
            </ul>

            <h2>Sécurité de Vos Données Personnelles</h2>
            <p>
              La sécurité de Vos Données Personnelles est importante pour Nous, mais rappelez-vous qu'aucune méthode
              de transmission sur Internet ou méthode de stockage électronique n'est sécurisée à 100%. Bien que Nous
              nous efforcions d'utiliser des moyens commercialement acceptables pour protéger Vos Données Personnelles,
              Nous ne pouvons garantir leur sécurité absolue.
            </p>

            <h1>Confidentialité des Enfants</h1>
            <p>
              Notre Service ne s'adresse à personne de moins de 13 ans. Nous ne collectons pas sciemment d'informations
              personnellement identifiables de quiconque de moins de 13 ans. Si Vous êtes un parent ou un tuteur et
              que Vous savez que Votre enfant Nous a fourni des Données Personnelles, veuillez Nous contacter. Si Nous
              prenons conscience que Nous avons collecté des Données Personnelles de quiconque de moins de 13 ans sans
              vérification du consentement parental, Nous prenons des mesures pour supprimer ces informations de Nos
              serveurs.
            </p>
            <p>
              Si Nous devons nous appuyer sur le consentement comme base légale pour traiter Vos informations et que
              Votre pays exige le consentement d'un parent, Nous pouvons exiger le consentement de Votre parent avant
              de collecter et d'utiliser ces informations.
            </p>

            <h1>Liens vers d'Autres Sites Web</h1>
            <p>
              Notre Service peut contenir des liens vers d'autres sites web qui ne sont pas exploités par Nous. Si Vous
              cliquez sur un lien tiers, Vous serez dirigé vers le site de ce tiers. Nous Vous conseillons fortement de
              consulter la Politique de Confidentialité de chaque site que Vous visitez.
            </p>
            <p>
              Nous n'avons aucun contrôle sur et n'assumons aucune responsabilité pour le contenu, les politiques de
              confidentialité ou les pratiques des sites ou services tiers.
            </p>

            <h1>Modifications de Cette Politique de Confidentialité</h1>
            <p>
              Nous pouvons mettre à jour Notre Politique de Confidentialité de temps à autre. Nous Vous informerons de
              tout changement en publiant la nouvelle Politique de Confidentialité sur cette page.
            </p>
            <p>
              Nous Vous informerons par e-mail et/ou un avis bien visible sur Notre Service, avant que le changement ne
              devienne effectif et mettrons à jour la date de "Dernière mise à jour" en haut de cette Politique de
              Confidentialité.
            </p>
            <p>
              Vous êtes conseillé de consulter cette Politique de Confidentialité périodiquement pour tout changement.
              Les modifications de cette Politique de Confidentialité sont effectives lorsqu'elles sont publiées sur
              cette page.
            </p>

            <h1>Contactez-Nous</h1>
            <p>Si vous avez des questions sur cette Politique de Confidentialité, Vous pouvez nous contacter :</p>
            <ul>
              <li>Par email : hello@tangagroup.africa</li>
              <li>Par téléphone : +225 27 22 49 49 49</li>
            </ul>
          </Text>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
};
